var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-message--system",style:(_vm.messageColors)},[_vm._v(_vm._s(_vm.data.text)),(_vm.data.meta)?_c('p',{staticClass:"sc-message--meta",style:({color: _vm.messageColors.color})},[_vm._v(_vm._s(_vm.data.meta))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }